function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup427318261(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 427318261",
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.743 0H6.25609C4.59726 0.00126406 3.00673 0.660792 1.83376 1.83376C0.660792 3.00673 0.00126406 4.59726 0 6.25609V14.743C0.00101126 16.402 0.660427 17.9927 1.83343 19.1659C3.00642 20.3391 4.59709 20.9987 6.25609 21H14.743C16.4019 20.9985 17.9924 20.3387 19.1653 19.1656C20.3383 17.9925 20.9978 16.4019 20.999 14.743V6.25609C20.9983 4.59711 20.3389 3.00628 19.1658 1.8332C17.9928 0.660125 16.4019 0.000758856 14.743 0ZM18.8876 14.743C18.8873 15.8421 18.4506 16.8962 17.6734 17.6734C16.8962 18.4506 15.8421 18.8873 14.743 18.8876H6.25609C5.71185 18.8876 5.17295 18.7804 4.67015 18.5721C4.16735 18.3638 3.71052 18.0585 3.32573 17.6736C2.94094 17.2887 2.63574 16.8318 2.42755 16.329C2.21937 15.8261 2.11228 15.2872 2.11241 14.743V6.25609C2.11228 5.7119 2.21938 5.17302 2.42757 4.67022C2.63577 4.16743 2.94098 3.71059 3.32579 3.32579C3.71059 2.94098 4.16743 2.63577 4.67022 2.42757C5.17301 2.21938 5.7119 2.11228 6.25609 2.11241H14.743C15.8418 2.11266 16.8957 2.54931 17.6727 3.32634C18.4497 4.10338 18.8864 5.1572 18.8866 6.25609L18.8876 14.743Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.4998 5.05331C7.5044 5.05331 5.07031 7.48836 5.07031 10.4828C5.07031 13.4772 7.50536 15.9122 10.4998 15.9122C13.4942 15.9122 15.9292 13.4772 15.9292 10.4828C15.9292 7.48836 13.4951 5.05331 10.4998 5.05331ZM10.4998 13.7998C9.62003 13.7999 8.77627 13.4506 8.15412 12.8286C7.53196 12.2066 7.18237 11.363 7.18224 10.4832C7.18212 9.60351 7.53147 8.75976 8.15344 8.1376C8.77542 7.51544 9.61907 7.16585 10.4988 7.16572C11.3785 7.1656 12.2223 7.51495 12.8445 8.13692C13.4666 8.7589 13.8162 9.60256 13.8163 10.4823C13.8165 11.362 13.4671 12.2058 12.8451 12.8279C12.2231 13.4501 11.3795 13.7997 10.4998 13.7998ZM15.9407 3.79236C16.1979 3.79255 16.4493 3.86899 16.6631 4.01202C16.8769 4.15506 17.0435 4.35826 17.1419 4.59596C17.2403 4.83365 17.2659 5.09517 17.2157 5.34746C17.1655 5.59975 17.0416 5.83148 16.8597 6.01338C16.6778 6.19528 16.4461 6.31917 16.1938 6.3694C15.9415 6.41964 15.68 6.39395 15.4423 6.2956C15.2046 6.19724 15.0014 6.03063 14.8583 5.81682C14.7153 5.60301 14.6389 5.3516 14.6387 5.09436C14.6387 4.37654 15.1255 3.79236 15.9407 3.79236Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup427318261);
export default __webpack_public_path__ + "static/media/Group 427318261.1dd7a3849ae6be56d85472041f39cbe7.svg";
export { ForwardRef as ReactComponent };